export default {
  title: 'Betaal met Pix',
  hint: 'Kopieer de code en plak deze in Pix in je bankapp, of scan de QR-code ermee.',
  copy: 'Pix-code kopiëren',
  copied: 'Code gekopieerd',
  qr_alt: 'Pix QR-code',
  expires_in: 'De code verloopt over {{time}}',
  waiting: 'We bevestigen je bestelling zodra je bank de betaling verstuurt.',
  open_page: 'Open in plaats daarvan de betaalpagina',
  expired: 'Deze Pix-code is verlopen. Start de betaling opnieuw voor een nieuwe.',
  cancel: 'Betaling annuleren',
  checking: 'Je betaling wordt gecontroleerd…',
  close: 'Sluiten',
};
